// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xax2y{margin-block-start:20px}.ejt2h{margin-block-start:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `Xax2y`,
	"field": `ejt2h`
};
export default ___CSS_LOADER_EXPORT___;
